module.exports = __webpack_public_path__ + "img/page-ico.d0167941.png";